module.exports = __webpack_public_path__ + "media/images/admin/icons/file-minus-24ccbfafe7a55cf96ed9613dc5ecf5fa.svg";